import Vue from 'vue';
import VueRouter from 'vue-router';
// import { Store, } from '~/apps/move-within/store';
// import { multiGuard, } from '~/utils/vue-router-multiguard';
// import Index from './pages/index.vue';
// type NavigationGuard = import('vue-router').NavigationGuard;

Vue.use(VueRouter);

const prefix = '/move-within';

// const RequiresMoveOutDetails: NavigationGuard = (_to, _from, next) => {
// 	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
// 	if (!Store.getters.hasExistingMoveOutDetails) {
// 		next('/');
// 		return;
// 	}

// 	next();
// };

// const RequiresMoveinDetails: NavigationGuard = (_to, _from, next) => {
// 	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
// 	if (!Store.getters.hasExistingMoveingDetails) {
// 		next('/');
// 		return;
// 	}

// 	next();
// };

// const RequiresCustomerDetails: NavigationGuard = (_to, _from, next) => {
// 	if (!Store.getters.hasExistingUserDetails) {
// 		next('/');
// 		return;
// 	}
// 	next();
// };

// const RequiresCompletedDetails: NavigationGuard = (_to, _from, next) => {
// 	if (Store.getters.hasCompletedMoveIn) {
// 		next();
// 		return;
// 	}

// 	next({ name: 'MoveWithinCheckAndConfirm', });
// };

export const Router = new VueRouter({
	base: prefix,
	mode: 'history',
	scrollBehavior() {
		return { x: 0, y: 0, };
	},
	routes: [
		{
			path: `/`,
			component: {
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				render: (c: any) => c('router-view'),
			},
			beforeEnter() {
				const pathname = `/your-account/login?redirectUrl=%2Fmove-within`;
				window.location.href = pathname;
			},
			// children: [
			// 	{ path: '', component: Index, },
			// 	{ path: `your-details`, component: () => import('./pages/your-details.vue').then((m) => m.default), },
			// 	{ path: `moving-from`, component: () => import('./pages/moving-from.vue').then((m) => m.default), beforeEnter: multiGuard([ RequiresCustomerDetails, RequiresMoveOutDetails, ]), },
			// 	{ path: `your-final-bill`, component: () => import('./pages/your-final-bill.vue').then((m) => m.default), beforeEnter: multiGuard([ RequiresCustomerDetails, RequiresMoveOutDetails, ]), },
			// 	{ path: `moving-details`, component: () => import('./pages/moving-details.vue').then((m) => m.default), beforeEnter: multiGuard([ RequiresCustomerDetails, RequiresMoveOutDetails, ]), },
			// 	{ path: `payment-details`, component: () => import('./pages/payment-details.vue').then((m) => m.default), beforeEnter: multiGuard([ RequiresCustomerDetails, RequiresMoveOutDetails, RequiresMoveinDetails, ]), },
			// 	{ path: `check-and-confirm`, name: 'MoveWithinCheckAndConfirm', component: () => import('./pages/check-and-confirm.vue').then((m) => m.default), beforeEnter: multiGuard([ RequiresCustomerDetails, RequiresMoveinDetails, RequiresMoveOutDetails, ]), },
			// 	{ path: `success`, component: () => import('./pages/move-within-success.vue').then((m) => m.default), beforeEnter: multiGuard([ RequiresCustomerDetails, RequiresCompletedDetails, RequiresMoveinDetails, RequiresMoveOutDetails, ]), },
			// 	{ path: `successful`, component: () => import('./pages/move-within-success.vue').then((m) => m.default), beforeEnter: multiGuard([ RequiresCustomerDetails, RequiresCompletedDetails, RequiresMoveinDetails, RequiresMoveOutDetails, ]), },
			// 	{ path: `sew`, component: () => import('./pages/sew.vue').then((m) => m.default), },
			// ],
		},
	],
});

// Router.afterEach((to) => {
// 	Store.commit.setActiveAlert(to.fullPath);
// });
